export default __webpack_public_path__ + "static/media/cpt-boomerang.5b977b50.png";